<!-- //
工作台
@auth xuyd
@date 2024-05-02
//-->
<template>
  <div class="workbench-container">
    <WbToolbar @click="handleToolCmd" :toolbar-data="toolbarData"/>

    <WbRulerTool class="workbench-ruler"
                 :step-length="50"
                 :parent="true"
                 :position="'relative'"
                 :is-scale-revise="true">
      <div class="grid-line">
        <div id="workbench" class="workbench"
             :style="{
                transform: `scale(${toolbarData.scale})`,
                width: workbenchProps.width + 'px',
                height: workbenchProps.height + 'px',
                'background-color': workbenchProps.backgroundColor,
              }"
             @click.self="handleWorkbenchClick"
             @dragover="handleWidgetDragOver($event)"
             @drop="handleWidgetDrop($event)"
        >

          <WidgetView class="widget-item"
                      ref="refDraggableWidget"
                      v-for="(widgetItem, index) in widgetViewList"
                      :widget="widgetItem"
                      :active="selectedWidget ? (selectedWidget.id === widgetItem.id) : false"
                      :scale="toolbarData.scale"
                      :key="index"
                      @onActivated="handleWidgetActivated(index, widgetItem)"
                      @contextmenu.prevent.native="handleWidgetCtxMenu(widgetItem, $event)"
                      @mousedown.prevent.native="handleWidgetMouseDown(index, widgetItem, $event)">
            <component :is="widgetItem.widgetProps.widgetViewName"
                       :widget-props="widgetItem.widgetProps"
                       :style="{
                            width: $util.num2px(widgetItem.widgetProps.viewProps.width),
                            height: $util.num2px(widgetItem.widgetProps.viewProps.height)
                          }"/>
          </WidgetView>
        </div>
      </div>
    </WbRulerTool>
  </div>
</template>

<script>

import {widgetPackage} from '../../widget/index.js';
import * as WidgetUtil from "@/views/datavisual/utils/util";
import {widgetMenuList} from "@/views/datavisual/widget/widgetMenu"; // 组件库

// 工具栏配置的组件注册{FormXXX:{}, ViewXXX: {}}
const regComponents = WidgetUtil.registerWidget(widgetMenuList, widgetPackage);

export default {
  name: 'WbWidgetProps',
  components: {...regComponents},
  data() {
    return {}
  },
  props: {
    selectedWidget: Object,
    workbenchProps: Object,
  },
}
</script>

<style scoped lang="less">
</style>
